import { render, staticRenderFns } from "./ChipFilter.vue?vue&type=template&id=18f8919e&"
import script from "./ChipFilter.vue?vue&type=script&lang=ts&"
export * from "./ChipFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports